import React, { useRef, useEffect } from 'react';
import { IconType } from 'react-icons'; 

interface IButtonProps {
    id?: string;
    type?: 'button' | 'submit' | 'reset';
    text?: string;
    title?: string;
    buttonStyle?: string;
    size?: string;
    intent?: string;
    disabled?: boolean;
    reactIcon?: IconType;
    iconStyle?: React.CSSProperties;
    iconHoverColor?: 'red' | 'green' | 'blue';
    icon?: string;
    onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    style?: React.CSSProperties;
    toolTip?: string;
    className?: string;
    form?: string;
    iconImage?: string;
}

const Button = (props: IButtonProps) => {
    const buttonRef = useRef<HTMLButtonElement>(undefined);

    const disableClickHandler = () => {
        if (buttonRef.current && buttonRef.current.form && buttonRef.current.type === 'submit') {
            buttonRef.current.form.dispatchEvent(new Event('submit', { cancelable: true }));
        }
        if (buttonRef.current) {
            buttonRef.current.disabled = true;
        }
        window.setTimeout(() => {
            if (buttonRef.current) {
                buttonRef.current.disabled = false;
            }
        }, 500);
    };

    useEffect(() => {
        if (buttonRef.current) {
            buttonRef.current.addEventListener('click', disableClickHandler);
        }
        return () => {
            if (buttonRef.current) {
                buttonRef.current.removeEventListener('click', disableClickHandler);
            }
        };
    }, [buttonRef.current]);

    const buttonClass = `dlc-form-button-${props.buttonStyle || 'default'} ${props.size || 'normal'} ${props.intent} ${props.toolTip ? 'tooltip' : ''
        } ${props.disabled ? 'disabled' : ''} ${!!props.className ? props.className : ''}`;

    let iconElement = undefined;
    switch (props.icon) {
        case 'user-plus':
            iconElement = <i className="fas fa-user-plus" />;
            break;
        case 'trash':
            iconElement = <i className="fas fa-trash" />;
            break;
        case 'contract':
            iconElement = <i className="fas fa-file" />;
            break;
        case 'shadow':
            iconElement = <i className="fas fa-user-secret" />;
            break;
        case 'edit':
            iconElement = <i className="fas fa-edit" />;
            break;
        default:
            break;
    }

    return (
        <button
            id={!!props.id ? props.id : ''}
            className={buttonClass}
            type={props.type || 'button'}
            onClick={props.disabled ? undefined : props.onClick || undefined}
            disabled={props.disabled}
            title={props.title}
            style={props.style}
            ref={buttonRef}
            form={props.form}
        >
            {props.reactIcon && 
                <props.reactIcon 
                    className={props.iconHoverColor ? `icon-button-${props.iconHoverColor}hover` : ``}
                    style={props.iconStyle}
                />}
            {iconElement || props.text}
            {props.iconImage && <img className={`icon-button-${props.iconHoverColor}hover`} style={props.iconStyle} src={props.iconImage}/>}
            {props.toolTip && <span className="tooltiptext">{props.toolTip}</span>}
        </button>
    );
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/controls/forms/redesign/FormButton.tsx